<div #editorContainer class="editorContainer"></div>

<div class="d-flex justify-content-end">
    <!-- <div >
        <button class="btn btn-sm btn-primary my-2" (click)="onSubmit()" >
            Submit
        </button>
    </div> -->
</div>

<!-- <div *ngIf="isLoading" class="loader"></div> -->
